"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _lodash = _interopRequireDefault(require("lodash.get"));

var _MenuRender = _interopRequireDefault(require("./MenuRender"));

require("./style.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = {
  name: 'Aside',
  components: {
    MenuRender: _MenuRender.default
  },
  props: ['menuId', 'menuData', 'isCollapse', 'updateMenuId'],
  data: function data() {
    return {
      activeId: '0',
      defaultOpeneds: [0],
      flag: false
    };
  },
  created: function created() {
    this.listFilter();
    this.setIndex();
  },
  mounted: function mounted() {
    this.redirect = this.redirect.bind(this);
  },
  updated: function updated() {
    this.listFilter();
    this.setIndex();
  },
  render: function render() {
    var h = arguments[0];
    var activeId = this.activeId,
        defaultOpeneds = this.defaultOpeneds,
        isCollapse = this.isCollapse,
        menuData = this.menuData,
        redirect = this.redirect;
    return h("el-scrollbar", {
      "class": "fe-aside"
    }, [this.$scopedSlots.default && this.$scopedSlots.default(), h(_MenuRender.default, {
      "attrs": {
        "defaultActive": activeId,
        "defaultOpeneds": defaultOpeneds,
        "uniqueOpened": true,
        "collapse": isCollapse,
        "collapseTransition": false,
        "menus": menuData,
        "redirect": redirect
      }
    })]);
  },
  methods: {
    setIndex: function setIndex() {
      this.activeId = "".concat(this.ergodic(this.menuData, this.menuId));
      this.flag = false;
      this.updateMenuId(this.activeId);
    },
    ergodic: function ergodic(list, id) {
      var mid = 0;
      if (this.flag) return;

      for (var index = 0; index < list.length; index += 1) {
        var item = list[index];
        if (this.flag) break;

        if (item.name === id) {
          if (item.meta.relation) {
            mid = this.ergodic(list, item.meta.relation);
          } else {
            mid = item.id;
          }

          this.flag = true;
          break;
        } else if (item.children) {
          mid = this.ergodic(item.children, id);
        }
      }

      return mid;
    },
    checkHidden: function checkHidden(submenu, id) {
      return submenu.find(function (item) {
        return item.id === id && item.meta.hidden;
      });
    },
    redirect: function redirect(_ref) {
      var path = _ref.path,
          title = _ref.meta.title;
      this.$router.push(path);
    },
    formatId: function formatId(menu, parent) {
      var _this = this;

      menu.forEach(function (item, index) {
        if (parent) {
          item.id = "".concat(parent.id, "-").concat(index);
        } else {
          item.id = "".concat(index);
        }

        if (item.children) _this.formatId(item.children, item);
      });
    },
    listFilter: function listFilter() {
      this.formatId(this.menuData);
    }
  }
};
exports.default = _default;